// src/context/FiltersContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

const FiltersContext = createContext();

export const useFilters = () => {
  const context = useContext(FiltersContext);
  if (!context) {
    throw new Error('useFilters must be used within a FiltersProvider');
  }
  return context;
};

export const FiltersProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    if (typeof window === 'undefined') return false;
    const stored = window.localStorage.getItem('filters.isCollapsed');
    return stored === 'true';
  });

  const [currentPage, setCurrentPage] = useState('database');
  const [filterOptions, setFilterOptions] = useState({});
  const [activeFilters, setActiveFilters] = useState({});
  const [filterCallbacks, setFilterCallbacks] = useState({});

  const toggleCollapse = useCallback(() => {
    setIsCollapsed((prev) => {
      const next = !prev;
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('filters.isCollapsed', next ? 'true' : 'false');
      }
      return next;
    });
  }, []);

  const updateFilterOptions = useCallback((page, options) => {
    setFilterOptions((prev) => ({
      ...prev,
      [page]: options
    }));
  }, []);

  const updateActiveFilters = useCallback((page, filters) => {
    setActiveFilters((prev) => ({
      ...prev,
      [page]: filters
    }));
  }, []);

  const registerFilterCallbacks = useCallback((page, callbacks) => {
    setFilterCallbacks((prev) => ({
      ...prev,
      [page]: callbacks
    }));
  }, []);

  const value = {
    isCollapsed,
    toggleCollapse,
    currentPage,
    setCurrentPage,
    filterOptions,
    updateFilterOptions,
    activeFilters,
    updateActiveFilters,
    filterCallbacks,
    registerFilterCallbacks,
  };

  return (
    <FiltersContext.Provider value={value}>
      {children}
    </FiltersContext.Provider>
  );
};
